import { getErrorString } from '../../utility/utility';

import actions from './actions';

const { FETCH_LEADS_BEGIN, FETCH_LEADS_SUCCESS, FETCH_LEADS_ERR } = actions;

const initialState = {
  list: null,
  loading: true,
  error: null,
  filters: [],
  pagination: { current: 0, pageSize: 0 },
};

const LeadsManagementReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_LEADS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LEADS_SUCCESS:
      const { viewType, ...rest } = data;

      return {
        ...state,
        ...rest,
        ...(viewType === 'mobile' && { list: [...(state.list ? state.list : []), ...rest?.list] }),
        error: null,
        loading: false,
      };

    case FETCH_LEADS_ERR:
      return {
        ...state,
        error: getErrorString(err),
        loading: false,
      };

    default:
      return state;
  }
};

export { LeadsManagementReducer };
